// extracted by mini-css-extract-plugin
export var copyableField = "_n2-4";
export var customerBadge = "_n2-0";
export var customerInfoTitle = "_n2-2";
export var details = "_n2-1";
export var dropdownContainer = "_n2-5";
export var dropdownImage = "_n2-6";
export var editAssigneeForm = "_n2-a";
export var editButton = "_n2-3";
export var email = "_n2-7";
export var hidden = "_n2-d";
export var input = "_n2-8";
export var saveButton = "_n2-b";
export var shopifyIcon = "_n2-c";
export var suggestionBadge = "_n2-e";
export var suggestionText = "_n2-f";
export var username = "_n2-9";